export const saveFile = (data: any, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  console.log(fileName);
  document.body.appendChild(link);
  link.click();
};
